
/**
 * JavaScript React Framework
 */
import React from 'react';

/**
 * React-Bootstrap
 */ 
import { MenuItem } from 'react-bootstrap';

/**
 * Cascading StyleSheets
 */
 import 'bootstrap/dist/css/bootstrap.min.css';
 
/**
 * Note: Your components tell React what you want to render
 */
class NavBarMenuItem extends React.Component {
	render() {
		return (
				<MenuItem eventKey={this.props.eventKey} href={this.props.href}><span className={"glyphicon glyphicon-" + this.props.glyph}></span>
					{this.props.children}
				</MenuItem>
		); // return
	} // render
} // class

/**
 * Expose default class
 */
export default NavBarMenuItem;



// WEBPACK FOOTER //
// ./src/cba/common/navbar/NavBarMenuItem.js